export default __webpack_public_path__ + "static/media/CCCream.2a09ec3f.jpeg";